import { DatePicker as AntdDatePicker, DatePickerProps } from 'antd';
import { FC, memo } from 'react';
import { Calendar4Week, ChevronDoubleLeft, ChevronDoubleRight, ChevronLeft, ChevronRight } from 'react-bootstrap-icons';

import dayjs from '@seolens/date-manager';
import locale from 'antd/es/date-picker/locale/uk_UA';

type Props = Omit<
  DatePickerProps,
  'locale' | 'showTime' | 'inputRender' | 'format' | 'suffixIcon' | 'nextIcon' | 'prevIcon' | 'superNextIcon' | 'superPrevIcon'
> & {
  showTime?: boolean;
};

export const AppDatePicker: FC<Props> = memo(({ showTime, value, ...props }) => {
  return (
    <AntdDatePicker
      {...props}
      showTime={showTime ? { format: 'HH:mm:ss' } : false}
      format={`DD.MM.YYYY${showTime ? ' HH:mm:ss' : ''}`}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      value={value ? (dayjs.isDayjs(value) ? value : dayjs(new Date(value as any))) : undefined}
      locale={{
        ...locale,
        lang: {
          ...locale.lang,
          ok: 'Вказати',
          dateFormat: 'DD.MM.YYYY',
          dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
          previousYear: 'Попередній рік (Cmd + left)',
          nextYear: 'Наступний рік (Cmd + right)',
        },
      }}
      suffixIcon={<Calendar4Week />}
      nextIcon={<ChevronRight />}
      prevIcon={<ChevronLeft />}
      superNextIcon={<ChevronDoubleRight />}
      superPrevIcon={<ChevronDoubleLeft />}
    />
  );
});
